export default __webpack_public_path__ + "static/media/guided-flow.2f737c44.gif";